import requestStatuses from 'modules/common/constants/requestsStatuses';

import createReducer from 'shared/utils/createReducer';
import { LOGIN } from 'modules/auth/actions/login';
import { LOGOUT } from 'modules/auth/actions/logout';

import {
  FETCH_ALLOWED_CONTRACTS_COUNT,
} from 'modules/queues/common/actions/appointmentForm';


const defaultState = {
  allowedContracts: 0,
  fetchAllowedContractsStatus: requestStatuses.default,
};

export default createReducer(defaultState, {
  [FETCH_ALLOWED_CONTRACTS_COUNT.success]: (state, { payload: { totalCount } }) => ({
    ...state,
    allowedContracts: totalCount,
  }),

  [LOGIN.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
